import { BUSINESS } from "@/data/business";

export const PolicyPage = ({ title, intro, sections, testId, icon: Icon, children }) => {
  return (
    <div data-testid={testId} className="mx-auto max-w-2xl px-6 py-12">
      <p className="flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.2em] text-[#A84A32]">
        {Icon && <Icon size={16} weight="duotone" />} {BUSINESS.tradingAs} is operated by {BUSINESS.legalName}
      </p>
      <h1 className="mt-2 font-serif text-4xl text-[#2C2A28]">{title}</h1>
      <p className="mt-2 text-[#8A7F76]">{intro}</p>
      <div className="mt-8 space-y-5">
        {sections.map((s) => (
          <section key={s.h} className="rounded-lg border border-[#4A4540]/10 bg-white p-5">
            <h2 className="font-serif text-xl text-[#2C2A28]">{s.h}</h2>
            <p className="mt-2 leading-relaxed text-[#4A4540]">{s.p}</p>
          </section>
        ))}
      </div>
      {children}
      <div data-testid={`${testId}-contact`} className="mt-8 rounded-lg bg-[#2E3B31] p-5 text-[#FBF4E8]">
        <p className="font-serif text-lg">Contact us</p>
        <p className="mt-1 text-sm text-[#C9CFC4]">
          {BUSINESS.legalName}, trading as {BUSINESS.tradingAs} ·{" "}
          <a href={`mailto:${BUSINESS.email}`} className="font-semibold text-[#E8C27A] underline-offset-2 hover:underline">{BUSINESS.email}</a>
        </p>
      </div>
    </div>
  );
};
